import React, { useContext, useState, useEffect } from "react";
import { CurrentUserContext } from "../../context/CurrentUserContext.js";
import {useTranslation} from '../../utils/hooks/translateHook.js'; 
import api from "../../utils/API/MainApi.js";
import "./Account.css";

const EditProfile = ({onClose}) => {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
   const t = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    email: "",
    country: "",
    city: "",
    phone: "",
  });

  useEffect(() => {
    if (currentUser) {
      setFormData({
        name: currentUser.name || "",
        lastname: currentUser.lastname || "",
        email: currentUser.email || "",
        country: currentUser.country || "",
        city: currentUser.city || "",
        phone: currentUser.phone || "",
      });
    }
  }, [currentUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      const response = await api.updateProfile( formData);
      const updatedUser = response.user || response;
      setCurrentUser(updatedUser);
      localStorage.setItem("user", JSON.stringify(updatedUser));
      alert(t("successUpdateProfile"));
      onClose();
    } catch (err) {
      console.error("Profile update failed:", err);
      alert(t("errorUpdateProfile"));
    }
  };

  return (
    <div className="profile-info">
      <ul>
        {[
            { field: "name", label: "First Name" },
            { field: "lastname", label: "Last Name" },
            { field: "email", label: "Email" },
            { field: "country", label: "Country" },
            { field: "city", label: "City" },
            { field: "phone", label: "Phone" },
        ].map(({ field, label })  => (
          <div key={field} className="edit-row">
            <label className="edit-label">{label}</label>
            <input
              name={field}
              value={formData[field] || ""}
              onChange={handleChange}
              placeholder={label}
              className="edit-input"
            />
          </div>
        ))}
      </ul>
      <div className="edit-profile-buttons">
        <button onClick={onClose}> {t('cancel')} </button>
        <button onClick={handleSave}> {t('save')} </button>
      </div>
    </div>
  );
};
export default EditProfile;
